import "./index.css";

const SuccessStories = () => {
  return (
    <div className="success-stories-container">
      <br/>
      <div className="testimonials-container1">
        <div className="success-stories-testimonials-container">
          <div className="success-stories-testimonial-image-container">
            <img
              src="/Images/successstories1.png"
              className="success-stories-testimonial-image"
            />
          </div>
          <div className="success-stories-testimonial-text-container">
            <p className="success-stories-testimonial-description">
              Before I joined the Aswa family, I was a B.Tech student. At that
              time there was no hope for me to continue my studies as we were in
              a financial trouble. I approached ASWA through Niranjan Sir. I got
              myself enrolled with team ASWA. Since then they have supported my
              entire Engineering degree along with hostel fees too. Now, I can
              proudly say that I'm doing my dream job in software because of
              ASWA. My family and I felt very happy after we found out about
              this program. We are always thankful to ASWA throughout our entire
              life.
            </p>
            <p className="success-stories-testimonial-name">
              Ramya Dudapaka <br />
              First Generation College-Going Student <br/>
              Cheyutha Scholarship Recipient
            </p>
          </div>
        </div>

        <div className="success-stories-testimonials-container">
          <div className="success-stories-testimonial-image-container">
            <img
              src="/Images/successStories2.png"
              className="success-stories-testimonial-image"
            />
          </div>
          <div className="success-stories-testimonial-text-container">
            <p className="success-stories-testimonial-description">
              We are a family of five members: me and two older sisters. My
              father is suffering from paralysis, and my mother's daily wages
              are the only income for my family, which is insufficient to run
              our family. Up until 10th grade, I studied in a government school,
              completed my diploma with 75%, and got an opportunity to join
              B-Tech 2nd Year at Narasaraopeta Engineering College in 2020. I
              was confused about continuing my higher studies, thinking about
              the expenses ahead. My mentor connected me with ASWA. After due
              verification and other formalities, I got the support of Rs. 5,000
              per month for my hostel and transportation. Adding to that, the
              government didn't reimburse students' fees twice in these most
              crucial times; again, ASWA supported me with Rs. 75,500/-. I don't
              know how to convey my gratitude for your support. Along with
              financial support and how your team guided and treated me, you
              motivated me to identify needy people in Corona, and you backed me
              in distributing basic necessities. Attending the Jeevanvidya
              course gave me some clarity on my personal life and how to manage
              it. I got a campus placement at TCS and will join in June or July
              2023. My heartfelt thanks to all the members of the organization
              for continuing their support. I wish to continue my association
              with ASWA.
            </p>
            <p className="success-stories-testimonial-name">
              Jagadeesh Nandyala <br />
              Markapuram Andhra Pradesh, First Generation College-Going Student <br/>
              Cheyutha Scholarship Recipient
            </p>
          </div>
        </div>

        <div className="success-stories-testimonials-container">
          <div className="success-stories-testimonial-image-container">
            <img
              src="/Images/successStories3.png"
              className="success-stories-testimonial-image"
            />
          </div>
          <div className="success-stories-testimonial-text-container">
            <p className="success-stories-testimonial-description">
              I have completed my schooling at a government school. Despite
              having no financial support, My mother encouraged me to pursue my
              studies. I reached out to ASWA through one of their sessions, and
              my life has changed since then. For the past 6 years, I have had
              ASWA support me for the purpose of education (financial support),
              motivation, and encouragement in my studies. Now I am happily
              completing my education. I'm very thankful to ASWA. I will do my
              best in my education and prove worthy of the organization's help.
            </p>
            <p className="success-stories-testimonial-name">
              Nunavath Lavanya <br/>
              First Generation College-Going Student <br/>
              Cheyutha Scholarship Recipient
            </p>
          </div>
        </div>

        <div className="success-stories-testimonials-container">
          <div className="success-stories-testimonial-image-container">
            <img
              src="/Images/successStories4.png"
              className="success-stories-testimonial-image"
            />
          </div>
          <div className="success-stories-testimonial-text-container">
            <p className="success-stories-testimonial-description">
              I have completed my 10th class in a government KGBV school. My
              father expired, and my mother, a farmer, encouraged me to pursue
              my studies. I was placed at Government Polytechnic Nizamabad in
              Civil Engineering. College is free, but we need to pay the hostel
              fee, which we cannot pay. Then I reached out to ASWA through one
              of our teachers. For the past four years, ASWA has supported me
              for the purpose of education; along with financial support, they
              also extend guidance for my life and career. Now I am happily
              doing my B-tech 3rd year. I'm very much thankful to ASWA. I will
              do my best to teach and prove worthy of the organisation's help.
              Once settled, I will join the ASWA.
            </p>
            <p className="success-stories-testimonial-name">
              Manoja Kaampe <br />
              Karimnagar, Telangana, <br/>
              First Generation College-Going Student <br/>
              Cheyutha Scholarship Recipient
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessStories;
